'use client';
import DOMPurify from 'isomorphic-dompurify';
import Image from 'next/image';
import React from 'react';
import { DateTime } from 'luxon';
// import { Button } from '@mui/material';
import Link from 'next/link';
import { enCodeLink } from '@/utils';

const RecentNews = ({ update }: any) => {
    // console.log(update);
    return (
        <Link href={enCodeLink(update?.headLine, update?.editorialId)} className="lg:w-[90%] w-full">
            <div className="w-full">
                <div className="flex flex-col gap-4 lg:gap-6 mx-auto">
                    <div className="flex flex-row sm:flex-row gap-2">
                        <div className="max-w-[50%] sm:w-1/2 lg:w-auto flex justify-center sm:justify-start ">
                            <Image
                                src={update.squareImage}
                                alt="News thumbnail"
                                width={1000}
                                height={1000}
                                className="h-auto max-w-[100%] sm:max-h-[250px] transition-transform duration-300 hover:scale-105"
                                style={{ borderRadius: '10px' }}
                            />
                        </div>
                        {/* Content */}
                        <div className="sm:w-1/2 max-w-[50%] flex flex-col items-center justify-center sm:items-start">
                            {/* Type and Date Container */}
                            <div className="flex flex-col w-full">
                                {/* Type and Date together */}
                                <div className="flex items-center w-full flex-wrap">
                                    <span
                                        className="whitespace-nowrap"
                                        style={{
                                            fontFamily: 'Inter',
                                            fontWeight: 700,
                                            fontSize: 'clamp(11px, 0.7vw, 14px)',
                                            lineHeight: '1',
                                            letterSpacing: '0.05em',
                                        }}
                                    >
                                        {update.editorialType.type}
                                    </span>
                                    <span className="text-black mx-1">•</span>
                                    <span
                                        className="whitespace-nowrap"
                                        style={{
                                            fontFamily: 'Inter',
                                            fontWeight: 500,
                                            fontSize: 'clamp(10px, 0.65vw, 13px)',
                                            lineHeight: '1',
                                            letterSpacing: '0.05em',
                                        }}
                                    >
                                        {DateTime.fromISO(update?.date).toFormat('dd MMM yyyy')}
                                    </span>
                                </div>

                                {/* Heading separate with spacing */}
                                <p
                                    className="line-clamp-4"
                                    style={{
                                        fontFamily: 'Inter',
                                        fontWeight: 400,
                                        fontSize: 'clamp(12px, 0.75vw, 15px)',
                                        lineHeight: '1.4',
                                        letterSpacing: '0.02em',
                                    }}
                                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(update.headLine) }}
                                />
                            </div>
                            {/* <p
                                className="text-[14px] line-clamp-2 max-h-[4rem] text-gray-500 mt-1 editor hidden text-center sm:text-left"
                                dangerouslySetInnerHTML={{
                                    __html: DOMPurify.sanitize(update?.subHeadLine),
                                }}
                            /> */}
                        </div>
                    </div>
                </div>
            </div>
        </Link>
    );
};

export default RecentNews;
